import React from "react";

function Barco() {
    return(
        <h1>
        This si the barco page</h1>
    );
}

export default Barco